import React from 'react';
import { Card, ConfigProvider } from 'antd';
import PropTypes from "prop-types";

const BasicCard = (props) => {
  return (
    <ConfigProvider
      theme={{
        components: {
          Card: {
            headerBg: props?.headerBg || '#d8e8ff',
          },
        },
        token: {
            colorTextHeading: props?.headerText || '#1677ff'
        }
      }}
    >
      <Card {...props}/>
    </ConfigProvider>
  );
};

BasicCard.propTypes = {
    headerBg: PropTypes.string,
    headerText: PropTypes.string
}

export default BasicCard;
